import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/pricingTableApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import PricingGridTemplateWidget from "../../../../components/Apps/PricingTable/Template/PricingGridTemplateWidget";
import PricingColumnsTemplateWidget from "../../../../components/Apps/PricingTable/Template/PricingColumnsTemplateWidget";
import ComparisonTableTemplateWidget from "../../../../components/Apps/PricingTable/Template/ComparisonTableTemplateWidget";
import ServicePlansTemplateWidget from "../../../../components/Apps/PricingTable/Template/ServicePlansTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/PricingTable/ContentTab";
import AppearanceTab from "../../../../components/Apps/PricingTable/AppearanceTab";

export default function CreateAgeVerification() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Pricing_Grid_Temp");
    const [selectedLayout, setSelectedLayout] = useState("pricing_grid_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("pricing-grid.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Pricing Table");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [pricingTableTabData, setPricingTableTabData] = useState({
        is_website_frontend: "",  
        is_multiple_table_mode: 1,
        default_table_type: "Billed Monthly",
        font_type: "Default",  
        is_widget_title: 1,
        title: "",  
        caption: "",  
        language_type: "English", 
        toggle_color: "#000", 
        arrow_size: 25, 
        arrow_background_color: "#fff",   
        arrow_background_color_on_hover: "#fff", 
        arrow_color_on_hover: "#4353ff",  
        arrow_color: "#4353ff",   
        is_show_picture: 1,   
        is_show_title: 1,   
        position_alignment: "left",   
        title_color: "#fff",   
        caption_color: "#fff",   
        title_size: "12px",   
        caption_size: "12px",   
        is_show_features: 1,  
        features_position_alignment: "left",   
        features_icon_color: "#fff",   
        features_text_color: "#fff",  
        is_show_price: 1, 
        price_position_alignment: "left",   
        price_color: "#fff",   
        price_caption_color: "#fff",   
        price_discount_text_color: "#000",  
        price_size: "12px", 
        price_discount_size: "14px", 
        price_caption_size: "14px", 
        is_show_button: 1, 
        button_position_alignment: "center", 
        button_color: "#fff", 
        button_label_color: "#4353ff", 
        button_caption_color: "#fff",  
        is_full_width: 1,  
        button_size_type: "Medium",  
        high_light_background_color: "#fff",  
        high_light_title_color: "#4353ff",  
        custom_css: "",    
        custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let toggle_color = "";
            let arrow_background_color = "";
            let arrow_background_color_on_hover = "";
            let arrow_color_on_hover = "";
            let arrow_color = "";
            let title_color = "";
            let caption_color = "";
            let features_icon_color = "";
            let features_text_color = "";
            let price_color = "";
            let price_caption_color = "";
            let price_discount_text_color = "";
            let button_color = "";
            let button_label_color = "";
            let button_caption_color = "";
            let high_light_background_color = "";
            let high_light_title_color = "";
        
            switch (activeTemplateSection) {
                case "Pricing_Grid_Temp":
                    toggle_color = "#000";
                    arrow_background_color = "#fff";
                    arrow_background_color_on_hover = "#fff";
                    arrow_color_on_hover = "#4353ff";
                    arrow_color = "#4353ff";
                    title_color = "#fff";
                    caption_color = "#fff";
                    features_icon_color = "#fff";
                    features_text_color = "#fff";
                    price_color = "#fff";
                    price_caption_color = "#fff";
                    price_discount_text_color = "#000";
                    button_color = "#fff";
                    button_label_color = "#4353ff";
                    button_caption_color = "#fff";
                    high_light_background_color = "#fff";
                    high_light_title_color = "#4353ff";
                    break;
                case "Pricing_Columns_Temp":
                    toggle_color = "#000";
                    arrow_background_color = "#fff";
                    arrow_background_color_on_hover = "#fff";
                    arrow_color_on_hover = "#4353ff";
                    arrow_color = "#4353ff";
                    title_color = "#fff";
                    caption_color = "#fff";
                    features_icon_color = "#fff";
                    features_text_color = "#fff";
                    price_color = "#fff";
                    price_caption_color = "#fff";
                    price_discount_text_color = "#000";
                    button_color = "#fff";
                    button_label_color = "#4353ff";
                    button_caption_color = "#fff";
                    high_light_background_color = "#fff";
                    high_light_title_color = "#4353ff";
                    break;
                case "Comparison_Table_Temp":
                    toggle_color = "#000";
                    arrow_background_color = "#fff";
                    arrow_background_color_on_hover = "#fff";
                    arrow_color_on_hover = "#4353ff";
                    arrow_color = "#4353ff";
                    title_color = "#fff";
                    caption_color = "#fff";
                    features_icon_color = "#fff";
                    features_text_color = "#fff";
                    price_color = "#fff";
                    price_caption_color = "#fff";
                    price_discount_text_color = "#000";
                    button_color = "#fff";
                    button_label_color = "#4353ff";
                    button_caption_color = "#fff";
                    high_light_background_color = "#fff";
                    high_light_title_color = "#4353ff";
                    break;
                case "Service_Plans_Temp":
                    toggle_color = "#000";
                    arrow_background_color = "#fff";
                    arrow_background_color_on_hover = "#fff";
                    arrow_color_on_hover = "#4353ff";
                    arrow_color = "#4353ff";
                    title_color = "#fff";
                    caption_color = "#fff";
                    features_icon_color = "#fff";
                    features_text_color = "#fff";
                    price_color = "#fff";
                    price_caption_color = "#fff";
                    price_discount_text_color = "#000";
                    button_color = "#fff";
                    button_label_color = "#4353ff";
                    button_caption_color = "#fff";
                    high_light_background_color = "#fff";
                    high_light_title_color = "#4353ff";
                    break;
                default:
                    toggle_color = "";
                    arrow_background_color = "";
                    arrow_background_color_on_hover = "";
                    arrow_color_on_hover = "";
                    arrow_color = "";
                    title_color = "";
                    caption_color = "";
                    features_icon_color = "";
                    features_text_color = "";
                    price_color = "";
                    price_caption_color = "";
                    price_discount_text_color = "";
                    button_color = "";
                    button_label_color = "";
                    button_caption_color = "";
                    high_light_background_color = "";
                    high_light_title_color = "";
            }
        
            // Update setPricingTableTabData state with the data
            setPricingTableTabData((prevData) => ({
                ...prevData,
                toggle_color: toggle_color,
                arrow_background_color: arrow_background_color,
                arrow_background_color_on_hover: arrow_background_color_on_hover,
                arrow_color_on_hover: arrow_color_on_hover,
                arrow_color: arrow_color,
                title_color: title_color,
                caption_color: caption_color,
                features_icon_color: features_icon_color,
                features_text_color: features_text_color,
                price_color: price_color,
                price_caption_color: price_caption_color,
                price_discount_text_color: price_discount_text_color,
                button_color: button_color,
                button_label_color: button_label_color,
                button_caption_color: button_caption_color,
                high_light_background_color: high_light_background_color,
                high_light_title_color: high_light_title_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updatePricingTableTabData = (key, value) => {
        setPricingTableTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Appearance", icon: "appearance.png", label: "Appearance" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(pricingTableTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Pricing_Table",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/pricing-table');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Pricing Table" app_type="Pricing_Table" app_slug="pricing-table"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Pricing_Grid_Temp" data-layout_type="pricing_grid_layout" data-template_image="pricing-grid.png" checked={activeTemplateSection === "Pricing_Grid_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/pricing-table/templates/pricing-grid.png`} alt="pricing-grid" />
                                    </div> 
                                    <div className="content_sub">Pricing Grid</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Pricing_Columns_Temp" data-layout_type="pricing_columns_layout" data-template_image="pricing-columns.png" checked={activeTemplateSection === "Pricing_Columns_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/pricing-table/templates/pricing-columns.png`} alt="pricing-columns" />
                                    </div>
                                    <div className="content_sub">Pricing Columns</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Comparison_Table_Temp" data-layout_type="comparison_table_layout" data-template_image="comparison-table.png" checked={activeTemplateSection === "Comparison_Table_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/pricing-table/templates/comparison-table.png`} alt="comparison-table" />
                                    </div>
                                    <div className="content_sub">Comparison Table</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Service_Plans_Temp" data-layout_type="service_plans_layout" data-template_image="service-plans.png" checked={activeTemplateSection === "Service_Plans_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/pricing-table/templates/service-plans.png`} alt="service-plans" />
                                    </div>
                                    <div className="content_sub">Service Plans</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/pricing-table/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab updatePricingTableTabData={updatePricingTableTabData} pricingTableTabData={pricingTableTabData} />
                            )}
                            {activeSection === "Appearance" && (
                              <AppearanceTab updatePricingTableTabData={updatePricingTableTabData} pricingTableTabData={pricingTableTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/pricing-table"><i className="fa fa-angle-left" aria-hidden="true"></i></Link> Back</h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/pricing-table/pricing-table.svg`} alt="pricing-table"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/pricing-table/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/pricing-table" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Pricing Table <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Pricing_Grid_Temp" && (
                      <PricingGridTemplateWidget pricingTableTabData={pricingTableTabData}/>
                    )}

                    {activeTemplateSection === "Pricing_Columns_Temp" && (
                      <PricingColumnsTemplateWidget pricingTableTabData={pricingTableTabData}/>
                    )}

                    {activeTemplateSection === "Comparison_Table_Temp" && (
                      <ComparisonTableTemplateWidget pricingTableTabData={pricingTableTabData}/>
                    )}

                    {activeTemplateSection === "Service_Plans_Temp" && (
                      <ServicePlansTemplateWidget pricingTableTabData={pricingTableTabData}/>
                    )} 
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 